/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import EDIT_FOLDER_PROJECT from "./EDIT_FOLDER_PROJECT";
import DELETE_FOLDER_PROJECT from "./DELETE_FOLDER_PROJECT";
import MOVE_FOLDER_TO_FOLDER from "./MOVE_FOLDER_TO_FOLDER";
import FOLDER_COLLAB from "./FOLDER_COLLAB";
import FLOAT_MENU from "../common_trivial/FLOAT_MENU";

/*REDUX*/
import {
  push_value_project,
  set_value_project,
} from "../../App/actions/projectActions";
import {
  get_folder_list_by_parent_folder_id,
  get_project_list_by_folder_id,
} from "../../App/actions/folderProjectAction";

/*PICTURE*/

/*FUNCTION*/
import format_date_short from "../../App/validation/format_date_short";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

class FOLDER_PROJECT_MODE_LIST extends Component {
  state = {
    modal_menu: false,
    anchor: null,
    folder_id: "",
    folder: {},
    modal_edit_folder: false,
    modal_delete_folder: false,
    modal_move_folder: false,
    modal_folder_collab: false,
  };

  on_click_folder = (folder) => {
    this.props.set_value_project({
      key: "folder_project_child_list",
      value: [],
    });
    this.props.set_value_project({
      key: "geo_project_list_child",
      value: [],
    });

    const folder_id = folder?._id;
    this.props.set_value_project({
      key: "folder_id_selected",
      value: folder_id,
    });
    this.props.set_value_project({
      key: "folder_object_selected",
      value: folder,
    });
    this.props.push_value_project({
      key: "folder_object_selected_list",
      value: folder,
    });
    this.props.push_value_project({
      key: "folder_id_selected_list",
      value: folder_id,
    });
    this.props.get_folder_list_by_parent_folder_id({
      folder_parent_id: folder_id,
    });
    this.props.get_project_list_by_folder_id({
      folder_id: folder_id,
    });
  };

  toggle_move_folder = () => {
    this.setState({
      modal_move_folder: !this.state.modal_move_folder,
      modal_menu: false,
    });
  };

  toggle_edit_folder = () => {
    this.setState({
      modal_edit_folder: !this.state.modal_edit_folder,
      modal_menu: false,
    });
  };

  toggle_delete_folder = () => {
    this.setState({
      modal_delete_folder: !this.state.modal_delete_folder,
      modal_menu: false,
    });
  };

  toggle_menu = (event) => {
    if (event) {
      const {
        folder_project_list,
        folder_object_selected_list,
        folder_project_child_list,
      } = this.props.project;
      let folder_final_list =
        folder_object_selected_list.length > 0
          ? folder_project_child_list
          : folder_project_list;
      const folder = folder_final_list.find(
        (item) => item?._id === event?.target?.id
      );
      this.props.set_value_project({
        key: "folder_id_selected_collab",
        value: event?.target?.id,
      });
      this.setState({
        modal_menu: true,
        anchor: event.currentTarget,
        folder_id: event.target.id,
        folder,
      });
    } else {
      this.setState({
        modal_menu: false,
        anchor: "",
        folder_id: "",
        folder: {},
      });
      this.props.set_value_project({
        key: "folder_id_selected_collab",
        value: "",
      });
    }
  };

  toggle_folder_collab = () => {
    this.setState({
      modal_folder_collab: !this.state.modal_folder_collab,
      modal_menu: false,
    });
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state
    const {
      modal_menu,
      anchor,
      modal_edit_folder,
      modal_delete_folder,
      modal_move_folder,
      modal_folder_collab,
      folder,
    } = this.state;

    //global props
    const {
      folder_project_list,
      folder_project_child_list,
      folder_id_selected_list,
      loading_item_array,
    } = this.props.project;

    //content
    let folder_list_final = [];
    if (folder_id_selected_list.length === 0) {
      folder_list_final = folder_project_list;
    } else {
      folder_list_final = folder_project_child_list;
    }

    const modal_menu_content = modal_menu && (
      <FLOAT_MENU
        id="basic-menu"
        anchorEl={anchor}
        open={modal_menu}
        onClose={this.toggle_menu}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        style={{ borderRadius: "15px" }}
      >
        <div>
          <button
            className="button_big margin_bottom button_white"
            onClick={this.toggle_move_folder}
          >
            {dict?.["Move to folder"]?.[language]}
          </button>
          <br />
          <button
            className="button_big margin_bottom button_white"
            onClick={this.toggle_edit_folder}
          >
            {dict?.["Edit"]?.[language]}
          </button>
          <br />
          <button
            className="button_big margin_bottom button_white"
            onClick={this.toggle_folder_collab}
          >
            {dict?.["Collaboration"]?.[language]}
          </button>
          <br />
          <button
            className="button_big button_white"
            onClick={this.toggle_delete_folder}
          >
            {dict?.["Delete"]?.[language]}
          </button>
        </div>
      </FLOAT_MENU>
    );

    const modal_edit_folder_content = modal_edit_folder && (
      <Modal
        modalSize="small"
        isOpen={modal_edit_folder}
        onClose={this.toggle_edit_folder}
      >
        <div className="box-body" id="box-body">
          <EDIT_FOLDER_PROJECT
            folder={folder}
            toggle_edit_folder={this.toggle_edit_folder}
          />
        </div>
      </Modal>
    );

    const modal_delete_folder_content = modal_delete_folder && (
      <Modal
        modalSize="small"
        isOpen={modal_delete_folder}
        onClose={this.toggle_delete_folder}
      >
        <div className="box-body" id="box-body">
          <DELETE_FOLDER_PROJECT
            folder={folder}
            toggle_delete_folder={this.toggle_delete_folder}
          />
        </div>
      </Modal>
    );

    const modal_move_folder_content = modal_move_folder && (
      <Modal
        modalSize="medium"
        isOpen={modal_move_folder}
        onClose={this.toggle_move_folder}
      >
        <div className="box-body" id="box-body">
          <MOVE_FOLDER_TO_FOLDER
            folder={folder}
            toggle_move_folder={this.toggle_move_folder}
          />
        </div>
      </Modal>
    );

    const modal_folder_collab_content = modal_folder_collab && (
      <Modal
        modalSize="medium"
        isOpen={modal_folder_collab}
        onClose={this.toggle_folder_collab}
      >
        <div className="box-body">
          <FOLDER_COLLAB />
        </div>
      </Modal>
    );

    let list_content;

    if (loading_item_array.includes("get_folder_list_by_parent_folder_id")) {
      list_content = (
        <div className="container_light">{dict?.["Load"]?.[language]}...</div>
      );
    } else if (folder_list_final.length === 0) {
      list_content = (
        <section
          className="container background_white"
          style={{ height: "100px", width: "200px" }}
        >
          <p className="text_medium sub_color">
            {dict?.["You don't have a folder yet"]?.[language]}
          </p>
        </section>
      );
    } else {
      list_content = (
        <section className="container_light background_white outline_grey">
          <table className="full_width">
            <tbody className="text_bold">
              <tr>
                <td>{dict?.["Name"]?.[language]}</td>
                <td>{dict?.["Created"]?.[language]}</td>
                <td>{dict?.["Modified"]?.[language]}</td>
                <td></td>
              </tr>
            </tbody>
            <tbody>
              {folder_list_final.map((folder, idx) => {
                const date_created = folder?.date_created
                  ? format_date_short(folder.date_created)
                  : "";
                const date_modified = folder?.date_modified
                  ? format_date_short(folder.date_modified)
                  : "";
                const name_original = folder?.name;
                let name = folder?.name;
                if (name.length > 70) {
                  const limit = 20;
                  const first = name?.slice(0, limit);
                  const last = name?.slice(name.length - limit, name.length);
                  name = first + "..." + last;
                }
                return (
                  <tr key={idx} className="button_white">
                    <td onClick={this.on_click_folder.bind(this, folder)}>
                      <p
                        className="max_one_lines cursor_pointer full_width inline"
                        title={name_original}
                        style={{ verticalAlign: "middle" }}
                      >
                        {name}
                      </p>
                      {folder?.groups?.length > 0 && (
                        <div
                          className="badge_small background_black margin_left"
                          style={{ verticalAlign: "middle" }}
                        >
                          {dict?.["Group"]?.[language]}
                        </div>
                      )}
                    </td>
                    <td>
                      <p className="text_small">{date_created}</p>
                    </td>
                    <td>
                      <p className="text_small">{date_modified}</p>
                    </td>
                    <td className="text_right">
                      <button
                        onClick={this.toggle_menu}
                        id={folder._id}
                        className="button_big almost_white"
                        style={{ width: "30px" }}
                      >
                        ⫶
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </section>
      );
    }

    return (
      <main className="margin_bottom">
        {modal_move_folder_content}
        {modal_delete_folder_content}
        {modal_edit_folder_content}
        {modal_menu_content}
        {modal_folder_collab_content}
        <h3 className="text_big margin_bottom">
          {dict?.["Folders"]?.[language]}
        </h3>
        {list_content}
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  project: state.project,
});

export default connect(mapStateToProps, {
  push_value_project,
  set_value_project,
  get_folder_list_by_parent_folder_id,
  get_project_list_by_folder_id,
})(FOLDER_PROJECT_MODE_LIST);
